module.exports = __webpack_public_path__ + "7c85e0a644711a8c66ab210d64cad7a8.jpg";